import React from 'react';
import Icon from './Icon';

const DrawPointIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 5.5A6.5 6.5 0 0 1 18.5 12M18.5 12A6.5 6.5 0 0 1 12 18.5M12 18.5A6.5 6.5 0 0 1 5.5 12M5.5 12A6.5 6.5 0 0 1 12 5.5M12 12H12.01"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default DrawPointIcon;
